const monthName = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const transformDateToDisplay = (d?: Date) =>
  d?.getUTCDate() + ' ' + monthName[d?.getUTCMonth() as number] + ' ' + d?.getUTCFullYear();
